module.exports = __webpack_public_path__ + "static/img/video.a409e51.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video.png
// module id = wa1j
// module chunks = 0